import { useContext } from 'react';
import { ApisContext } from './ApisContext';

export const useSweepUnauthenticatedApi = () => {
  const { dashboardUnauthenticatedAPI } = useContext(ApisContext);

  return dashboardUnauthenticatedAPI;
};
